import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class CaptainResource {
  constructor($resource, Upload) {
    "ngInject";

    this.Upload = Upload;
    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.captain).get(options);
  }

  get(id) {
    return this.$resource(apis.captain + id).get();
  }

  find(q) {
    return this.$resource(apis.captain + "find").get({ q });
  }

  search(query = "", params) {
    return this.$resource(apis.captain + "autocomplete/").get(
      assign(params, { query })
    );
  }

  post(item) {
    return this.$resource(apis.captain).save(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.captain + id + `/${name}`).save(item);
  }

  update(id, item) {
    return this.$resource(apis.captain + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  deductDebt(id, item) {
    return this.$resource(apis.captain + id + "/deduct_debt").save(item);
  }

  transactions(params) {
    return this.$resource(apis.transactions).get(params);
  }

  notes(query) {
    return this.$resource(apis.notes).get(query);
  }

  addNote(id, item) {
    return this.$resource(apis.captain + id + "/note/").save(item);
  }

  updateNote(id, noteId, item) {
    return this.$resource(apis.captain + id + "/note/" + noteId, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  documentUpload(id, data) {
    const url = `${apis.captain}${id}/upload_document`;
    const request = this.Upload.upload({ url, data });
    return { $promise: request };
  }

  documentRemove(id, item) {
    return this.$resource(apis.captain + id + "/remove_document").delete(item);
  }

  assignedBuses(id, items) {
    return this.$resource(apis.captain + id + "/assigned_buses/").get(items);
  }

  getPaymentMethods(id, params) {
    return this.$resource(apis.captain + id + "/payment_methods").query(params);
  }

  updatePaymentMethods(id, item) {
    return this.$resource(apis.captain + id + "/payment_methods", null, {
      update: { method: "PATCH", isArray: true },
    }).update(item);
  }

  getDownloadLink(id, params) {
    return this.$resource(apis.captain + id + "/download_document").get(params);
  }

  assignGarage(id, garageLocation) {
    return this.$resource(apis.captain + id + "/update_garage/").save({
      loc: garageLocation,
    });
  }

  getDeactivationReasons(params) {
    return this.$resource(apis.captain + "deactivation_reasons").get(params);
  }

  verifyOTP(params) {
    return this.$resource(apis.captain + "otp/check").get(params);
  }

  getVerificationState(id) {
    return this.$resource(apis.captain + id + "/verification_state").get();
  }

  getAllBids({ id, ...options }) {
    return this.$resource(apis.captain + id + "/bids").get(options);
  }

  getBackgroundCheckState(id) {
    return this.$resource(apis.captain + id + "/background_check").get();
  }

  setBackgroundCheckState(id, params) {
    return this.$resource(apis.captain + id + "/background_check", null, {
      update: { method: "PATCH" },
    }).update(params);
  }
}

export default CaptainResource;



// WEBPACK FOOTER //
// ./src/resources/captain/captain.resource.js